import { Id, UpdateOptions, toast } from 'react-toastify'

import { IconName, IconV2 } from 'ui/components/Icon'

import * as SC from './styles'

const ThinCloseButton = ({ closeToast }: any) => (
  <SC.Button onClick={closeToast}>
    <IconV2 name={IconName.CROSS_OUTLINE} />
  </SC.Button>
)

export class Toast {
  static id: number | string

  static dismiss() {
    toast.dismiss()
  }

  static update(toastId: Id, options: UpdateOptions) {
    toast.update(toastId, options)
  }

  static success(title: React.ReactNode, message?: React.ReactNode) {
    toast.success(
      <SC.BigToastContent data-qa-message={message || title}>
        <SC.Title>
          <SC.IconSuccess name={IconName.CHECK_ROUND} /> {title || 'Success'}
        </SC.Title>
        {message && <SC.Content>{message}</SC.Content>}
      </SC.BigToastContent>,
      {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
        closeButton: ThinCloseButton
      }
    )
  }

  static successSmall(message: React.ReactNode) {
    toast.success(
      <SC.SmallToastContent data-qa-message={message}>
        <SC.IconSuccess name={IconName.CHECK_ROUND} /> {message}
      </SC.SmallToastContent>,
      {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
        closeButton: ThinCloseButton
      }
    )
  }

  static successSmallUpdatable(message: React.ReactNode) {
    if (toast.isActive(this.id)) {
      toast.update(this.id)
    } else {
      this.id = toast.success(
        <SC.SmallToastContent data-qa-message={message}>
          <SC.IconSuccess name={IconName.CHECK_ROUND} /> {message}
        </SC.SmallToastContent>,
        {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 5000,
          hideProgressBar: false,
          closeButton: ThinCloseButton
        }
      )
    }
  }

  static error(title: React.ReactNode, message?: React.ReactNode) {
    toast.error(
      <SC.BigToastContent data-qa-message={message || title}>
        <SC.Title>
          <SC.IconError name={IconName.WARNING_FILLED} /> {title || 'Error'}
        </SC.Title>
        {message && <SC.Content>{message}</SC.Content>}
      </SC.BigToastContent>,
      {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
        closeButton: ThinCloseButton
      }
    )
  }

  static errorSmall(message: React.ReactNode) {
    toast.error(
      <SC.SmallToastContent data-qa-message={message}>
        <SC.IconError name={IconName.WARNING_FILLED} /> {message}
      </SC.SmallToastContent>,
      {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
        closeButton: ThinCloseButton
      }
    )
  }

  static info(title: React.ReactNode, message?: React.ReactNode) {
    toast.info(
      <SC.BigToastContent data-qa-message={message || title}>
        <SC.Title>
          <SC.IconInfo name={IconName.INFO_ROUND} /> {title || 'Information'}
        </SC.Title>
        {message && <SC.Content>{message}</SC.Content>}
      </SC.BigToastContent>,
      {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
        closeButton: ThinCloseButton
      }
    )
  }

  static infoSmall(message: React.ReactNode) {
    toast.info(
      <SC.SmallToastContent data-qa-message={message}>
        <SC.IconInfo name={IconName.INFO_ROUND} /> {message}
      </SC.SmallToastContent>,
      {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
        closeButton: ThinCloseButton
      }
    )
  }
}
